<nz-table
  #basicTable
  [nzBordered]="bordered()"
  [nzLoading]="loading()"
  [nzSize]="size()"
  [nzPaginationType]="paginationType()"
  [nzShowPagination]="showPagination()"
  [nzShowSizeChanger]="showPageSizeChanger()"
  [nzData]="dataSource()"
  [nzFrontPagination]="frontPagination()"
  [nzTotal]="total()"
  [nzShowTotal]="showTotal()"
  [nzPageSize]="pageSize()"
  [nzPageIndex]="pageIndex()"
  [nzScroll]="scrollConfig()"
  (nzCurrentPageDataChange)="onCurrentPageDataChange($event)"
  (nzQueryParams)="sendQueryParams($event)"
>
  <thead>
  <tr>
    @if (isMultiSelect()) {
      <th
        [nzChecked]="checked"
        [nzIndeterminate]="indeterminate"
        nzLabel="Select all"
        [nzWidth]="'30px'"
        (nzCheckedChange)="onAllChecked($event)"
      ></th>
    }
    @for (column of columns(); track column.key) {
      <th
        [nzColumnKey]="column.columnKey || column.key"
        [nzWidth]="column.width"
        [nzShowSort]="column.sort"
        [nzSortFn]="column.sort"
        [nzAlign]="column?.align || 'left'"
        class="whitespace-pre"
      >
        {{ column.title }}
      </th>
    }
  </tr>
  </thead>
  <tbody>
    @for (row of basicTable.data; track row.id) {
      <tr>
        @if (isMultiSelect()) {
          <td
            [nzChecked]="setOfCheckedId.has(row.id!)"
            [nzDisabled]="row.disabled || false"
            (nzCheckedChange)="onItemChecked(row.id!, $event)"
          ></td>
        }
        @for (column of columns(); track column) {
          <td [nzAlign]="column?.align || 'left'">
            @if (column?.key && columnTemplates()[column.key]) {
              <ng-container
                *ngTemplateOutlet="
                  columnTemplates()[column.key];
                  context: { $implicit: row[column.key], row: row }
                "
              ></ng-container>
            } @else {
              {{ row[column.key] }}
            }
          </td>
        }
      </tr>
    }
  </tbody>
</nz-table>
